import { NgModule } from '@angular/core';
import { ChatMessageComponent } from './chat-message.component';

@NgModule({
  imports: [ChatMessageComponent],
  exports: [ChatMessageComponent],
})
export class ChatMessageModule {}
